export default __webpack_public_path__ + "static/media/PORTO_PLUS_PROTECAO_PARCIAL.420e49d2.png";